import React from 'react';
import Title from '../Title/Index';
import '../Aboutus/aboutus.css';
import Banner from '../Banner/Index';
import ImageTag from '../ImageTag/Index';

const Index = ({ Data }) => {
  if (!Data) return null;

  return (
    <>
      <section
        className='w-full flex flex-wrap p-100 mobileContainer'
        data-aos="fade-up"
        data-aos-offset="200"
        data-aos-duration="500"
        data-aos-once="true"
        data-aos-easing="ease-in-sine"
      >
        <div className='w-full lg:w-[900px] m-auto'>
          <Title
            firstHeading={Data.heading}
            secondHeading={Data.title}
            subTitle={Data.descp}
          />
        </div>

        <div className='w-full flex flex-wrap justify-content-end md:gap-5 gap-3 align-items-center flex-direction-mobile'>
          <div className='w-full xl:w-1/3 flex flex-wrap'>
            <ul
              className='flex flex-wrap'
              data-aos="fade-up"
              data-aos-offset="200"
              data-aos-duration="500"
              data-aos-once="true"
              data-aos-easing="ease-in-sine"
            >
              {Array.isArray(Data.features) && Data.features.map((item, index) => (
                <li key={index} className='w-1/2 sm:mb-8 sm:pr-8 mb-4 pr-4'>
                  <strong className='block font-bold text-gray-900'>
                    {item.label}
                  </strong>
                  <label className='block  text-gray-900'>
                    {item.content}
                  </label>
                  {index < Data.features.length - 2 && (
                    <hr className='mt-2 sm:mt-4 border-black-800 w-20 -left-5 relative' />
                  )}
                </li>
              ))}
            </ul>
          </div>

          <div className='w-full xl:w-1/2'>
            <ImageTag ImagePath={Data.featureBanner} ImageClass={'float-end'} />
          </div>
        </div>
      </section>

      {Data.bannerImage && (
        <Banner
          _parentClass="bgImage h-70vh flex-center"
          backgroundImage={Data.bannerImage}
        >
          <div className='w-full lg:w-[780px] m-auto'>
            <Title
              secondHeading={Data.bannerContent}
              _secondHeading={'bannerTitle text-white bg-black-500 flex px-sm-4 p-3 m-0'}
              _miniClass={'text-white'}
              _class={'m-0'}
            />
          </div>
        </Banner>
      )}
    </>
  );
};

export default Index;